<template>
  <ul :class="$style.component">
    <li
      v-for="(image, index) in item.images"
      :key="index"
      :class="imageClass(image)"
    >
      <BaseImage :image="image" :sizes="sizes(image)" />
      <div
        :class="$style.caption"
        v-if="image.description"
        v-html="image.description"
      ></div>
    </li>
  </ul>
</template>

<script>
import BaseImage from '@/components/base-image'

export default {
  components: { BaseImage },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  methods: {
    imageClass(image) {
      return [
        this.$style.image,
        this.isPortrait(image) ? this.$style['is-portrait'] : ''
      ]
    },
    isPortrait(image) {
      return image.ratio < 1
    },
    sizes(image) {
      if (this.isPortrait(image)) {
        return '(min-width: 100em) 585px, (min-width: 48em) 37vw, (min-width: 40em) 47vw, 75vw'
      }
      return '(min-width: 100em) 780px, (min-width: 48em) 50vw, (min-width: 40em) 63vw, 100vw'
    }
  }
}
</script>

<style lang="scss" module>
.component {
  @media (min-width: $small) {
    width: 66.6666%;
    max-width: 30em;
  }
}

.image {
  margin: var(--blank-line) 0;

  &.is-portrait {
    width: 75%;
  }
}
</style>
